<template>
  <div v-if="loading"   v-loading.fullscreen.lock="true" element-loading-text="绑定中正在跳转..." />
</template>
<script>
import { parseUrl } from '@/utils/client'
export default {
  name: 'BindQQ',
  data(){
    return {
      loading: true
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    getCode() {
      var path = window.location.href
      let code = parseUrl(path).code
      if (code) {
        window.localStorage.setItem('qqCode', code)
        this.loading = false;
        this.$router.push('/user')
        this.bindQQCallback(code);
      }
    },
    bindQQCallback(code) {
      this.$http.bind_qq({ code }).then(res => {
        // this.$toast("绑定成功!");
        // window.close();
        // this.windowOpen.close();
        this.$store.dispatch("getMyInfo");
      });
    },
  },
}
</script>
<style>
.el-loading-spinner .el-loading-text{
  text-align: center !important;
}
</style>